var render, staticRenderFns
import script from "./AdminLicenseRegistry.vue?vue&type=script&lang=js"
export * from "./AdminLicenseRegistry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b20450')) {
      api.createRecord('57b20450', component.options)
    } else {
      api.reload('57b20450', component.options)
    }
    
  }
}
component.options.__file = "resources/js/pages/AdminLicenseRegistry.vue"
export default component.exports